var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "failed-folder_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .5h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#failed-folder_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.001 11.654c.153 0 .28-.052.384-.155a.521.521 0 00.155-.384.521.521 0 00-.155-.383.521.521 0 00-.384-.155.521.521 0 00-.383.155.521.521 0 00-.155.383c0 .153.051.28.155.384a.521.521 0 00.383.155zm0-2.436c.142 0 .261-.048.357-.144a.484.484 0 00.143-.356v-3a.484.484 0 00-.144-.356.484.484 0 00-.356-.144.483.483 0 00-.356.144.484.484 0 00-.144.356v3c0 .142.048.26.144.356a.484.484 0 00.357.144zm.001 5.615a6.17 6.17 0 01-2.47-.498 6.4 6.4 0 01-2.011-1.354 6.395 6.395 0 01-1.354-2.01 6.164 6.164 0 01-.499-2.47c0-.876.166-1.7.499-2.47A6.398 6.398 0 013.52 4.02a6.394 6.394 0 012.01-1.354 6.164 6.164 0 012.47-.5c.876 0 1.7.167 2.47.5.771.332 1.441.783 2.012 1.353.57.57 1.021 1.24 1.354 2.01.332.77.499 1.594.499 2.47 0 .876-.167 1.7-.5 2.47a6.397 6.397 0 01-1.353 2.011 6.394 6.394 0 01-2.01 1.354 6.164 6.164 0 01-2.47.5zm0-1c1.488 0 2.75-.516 3.783-1.55 1.033-1.033 1.55-2.294 1.55-3.783 0-1.489-.517-2.75-1.55-3.783C10.75 3.683 9.49 3.167 8 3.167c-1.489 0-2.75.516-3.783 1.55C3.185 5.75 2.668 7.01 2.668 8.5c0 1.489.517 2.75 1.55 3.783 1.033 1.034 2.294 1.55 3.783 1.55z",
    fill: "#F73C3C"
  }))));
}
export default SvgFailedFolder;